export default __webpack_public_path__ + "static/SurfaceImperfections003_1K_Normal-ce6b93b743255681220b408e7dbfc18a.jpg";